/**
 * useConnectionsState — Local state management for the connections page.
 */
import { useState, useEffect } from 'react';
import { Connection } from '@/types/connections';
import { useAuth } from '@/hooks/useAuth';

export interface ConnectionState {
  connections: Connection[];
  pendingConnections: Connection[];
  loading: boolean;
  error: string | null;
  setConnections: (connections: Connection[]) => void;
  setPending: (pendingConnections: Connection[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export function useConnectionsState(): ConnectionState {
  const [connections, setConnections] = useState<Connection[]>([]);
  const [pending, setPending] = useState<Connection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuth();
  
  // Reset state when user changes
  useEffect(() => {
    if (!user) {
      setConnections([]);
      setPending([]);
      setLoading(false);
    }
  }, [user]);
  
  return {
    connections,
    setConnections,
    pendingConnections: pending,
    setPending,
    loading,
    setLoading,
    error,
    setError
  };
}
